<!-- <div class="section">
  <app-service-chart
    [currentServices]="graph"
    [previousServices]="[]"
    [viewType]="selectedView"
  ></app-service-chart>
</div>

<div class="card-header flex justify-between items-center mt-3">
  <div class="exp">
    <h4 class="text-lg font-semibold">Amazon Web Services India Private Limited</h4>
  </div>
  <div class="ser mt-4 d-flex gap-4">
    <div>
      <p>Total active services</p>
      <h5><strong>{{ totactiveser }}</strong></h5>
    </div>
    <div>
      <p>Total service charges in USD</p>
      <h5 class="text-end">
        <strong>{{
          total !== null && total !== undefined
            ? (total | number : '1.2-2') + ' USD'
            : '-'
        }}</strong>
      </h5>
    </div>
  </div>
</div>

<div class="flex-wrap align-items-center justify-content-between p-3 border">
  <div class="d-flex flex-wrap align-items-center gap-4">
    <app-preferences
      [pref]="preferencesData"
      [monthYear]="monthYear"
      [filteredTag]="filteredTag"
      [selectedView]="selectedView"
      [accountId]="accountId"
      (pageSizeChange)="handlePageSizeChange($event)"
      (responseToParent)="handlePreferencesResponse($event)"
    >
    </app-preferences>
  </div>

  <div class="d-flex flex-wrap align-items-center gap-4 justify-content-between">
    <div class="input-group mb-4 w-50 mt-4">
      <span class="input-group-text bg-white border-end-0">
        <i class="fa-solid fa-magnifying-glass text-muted"></i>
      </span>
      <input
        type="text"
        [(ngModel)]="searchTerm"
        class="form-control border-start-0"
        placeholder="Filter by service or region name"
        (ngModelChange)="onSearch()"
      />
    </div>

    <div>
      <button class="btn btn-outline-primary" (click)="toggleExpandAll()">
        <i class="fa" [ngClass]="isExpandedAll ? 'fa-square-minus' : 'fa-square-plus'"></i>
        {{ isExpandedAll ? 'Minimize All' : 'Expand All' }}
      </button>
    </div>
  </div>
</div>

<div class="table-container np-table3">
  <ng-container *ngIf="weekHeaders?.length; else noDataAWS">
    <table class="table table-striped">
      <colgroup>
        <col style="width: auto; white-space: nowrap;" />
        <col *ngFor="let _ of [].constructor(weekHeaders.length * 2)" />
      </colgroup>

      <thead>
        <tr>
          <th>Services</th>
          <ng-container *ngFor="let week of weekHeaders">
            <th colspan="2">{{ week }}</th>
          </ng-container>
        </tr>
        <tr>
          <th></th>
          <ng-container *ngFor="let _ of weekHeaders">
            <th>(Base)</th>
            <th>(Final)</th>
          </ng-container>
        </tr>
      </thead>

      <tbody>
        <tr *ngIf="!filteredList || filteredList.length === 0">
          <td
            [attr.colspan]="weekHeaders?.length * 2 + 1"
            class="text-center text-muted py-3"
          >
            No data found
          </td>
        </tr>

        <ng-container *ngFor="let service of paginatedList">
          <tr class="bg-light">
            <td class="ps-2">
              <span (click)="toggleProductName(service)" style="cursor: pointer;">
                <i
                  class="fa me-1"
                  [ngClass]="isProductNameExpanded(service) ? 'fa-minus' : 'fa-plus'"
                ></i>
                {{ service.product_name }}
              </span>
            </td>
            <ng-container *ngFor="let cost of service.costs">
              <td><strong>{{ cost.base }}</strong></td>
              <td><strong>{{ cost.final }}</strong></td>
            </ng-container>
          </tr>

          <tr *ngIf="isProductNameExpanded(service)" class="bg-white">
            <td class="ps-3">
              <span
                *ngIf="service.regions?.length"
                (click)="toggle(service)"
                style="cursor: pointer;"
              >
                <i
                  class="fa me-1"
                  [ngClass]="service.expanded ? 'fa-minus' : 'fa-plus'"
                ></i>
                {{ service.service_name }}
              </span>
              <span *ngIf="!service.regions?.length">{{ service.service_name }}</span>
            </td>
            <ng-container *ngFor="let cost of service.costs">
              <td><strong>{{ cost.base }}</strong></td>
              <td><strong>{{ cost.final }}</strong></td>
            </ng-container>
          </tr>

          <ng-container *ngIf="service.expanded">
            <ng-container *ngFor="let region of service.regions">
              <tr>
                <td class="ps-4">
                  <span
                    *ngIf="region.product_families?.length"
                    (click)="region.expanded = !region.expanded"
                    style="cursor: pointer;"
                  >
                    <i
                      class="fa me-1"
                      [ngClass]="region.expanded ? 'fa-minus' : 'fa-plus'"
                    ></i>
                    {{ region.region }}
                  </span>
                  <span *ngIf="!region.product_families?.length">{{ region.region }}</span>
                </td>
                <ng-container *ngFor="let cost of region.costs">
                  <td>{{ cost.base }}</td>
                  <td>{{ cost.final }}</td>
                </ng-container>
              </tr>

              <ng-container *ngIf="region.expanded">
                <ng-container *ngFor="let pf of region.product_families">
                  <tr>
                    <td class="ps-5">{{ pf.name }}</td>
                    <ng-container *ngFor="let cost of pf.costs">
                      <td>{{ cost.base }}</td>
                      <td>{{ cost.final }}</td>
                    </ng-container>
                  </tr>
                </ng-container>
              </ng-container>
            </ng-container>
          </ng-container>
        </ng-container>
      </tbody>
    </table>

    <div
      class="d-flex justify-center align-items-center mt-3"
      *ngIf="totalPages > 1"
    >
      <i
        class="fa fa-angle-left fa-lg cursor-pointer mx-2"
        [class.text-muted]="currentPage === 1"
        (click)="goToPreviousPage()"
      ></i>
      <span class="mx-2">Page {{ currentPage }} of {{ totalPages }}</span>
      <i
        class="fa fa-angle-right fa-lg cursor-pointer mx-2"
        [class.text-muted]="currentPage >= totalPages"
        (click)="goToNextPage()"
      ></i>
    </div>
  </ng-container>

  <ng-template #noDataAWS>
    <div class="text-center text-muted py-3">No data found</div>
  </ng-template>
</div>

<div class="card-header flex justify-between items-center mt-3">
  <div class="exp">
    <h4 class="text-lg font-semibold">Amazon Web Services, Inc. - Marketplace</h4>
  </div>
  <div class="ser mt-4 d-flex gap-4">
    <div>
      <p>Total active services</p>
      <h5><strong>{{ market_totactiveser }}</strong></h5>
    </div>
    <div>
      <p>Total service charges in USD</p>
      <h5 class="text-end">
        <strong>{{
          market_total != null
            ? (market_total | number : '1.2-2') + ' USD'
            : '-'
        }}</strong>
      </h5>
    </div>
  </div>
</div>

<div class="d-flex flex-wrap align-items-center justify-content-between p-3 border mt-3">
  <div class="input-group mb-4 w-50 mt-4">
    <span class="input-group-text bg-white border-end-0">
      <i class="fa-solid fa-magnifying-glass text-muted"></i>
    </span>
    <input
      type="text"
      [(ngModel)]="market_searchTerm"
      (ngModelChange)="market_onSearch()"
      class="form-control border-start-0"
      placeholder="Filter by service or region name"
    />
  </div>

  <div>
    <button class="btn btn-outline-primary" (click)="market_toggleExpandAll()">
      <i
        class="fa"
        [ngClass]="market_isExpandedAll ? 'fa-square-minus' : 'fa-square-plus'"
      ></i>
      {{ market_isExpandedAll ? 'Minimize All' : 'Expand All' }}
    </button>
  </div>
</div>

<div class="table-container np-table3">
  <ng-container *ngIf="market_weekHeaders?.length; else noDataMarket">
    <table class="table table-striped">
      <colgroup>
        <col style="width: auto; white-space: nowrap;" />
        <col *ngFor="let _ of [].constructor(market_weekHeaders.length * 2)" />
      </colgroup>

      <thead>
        <tr>
          <th>Services</th>
          <ng-container *ngFor="let week of market_weekHeaders">
            <th colspan="2">{{ week }}</th>
          </ng-container>
        </tr>
        <tr>
          <th></th>
          <ng-container *ngFor="let _ of market_weekHeaders">
            <th>(Base)</th>
            <th>(Final)</th>
          </ng-container>
        </tr>
      </thead>

      <tbody>
        <tr *ngIf="!market_filteredList || market_filteredList.length === 0">
          <td
            [attr.colspan]="market_weekHeaders?.length * 2 + 1"
            class="text-center text-muted py-3"
          >
            No data found
          </td>
        </tr>

        <ng-container *ngFor="let market_service of market_filteredList">
          <tr>
            <td class="ps-2">
              <span
                *ngIf="market_service.regions?.length"
                (click)="market_service.expanded = !market_service.expanded"
                style="cursor: pointer;"
              >
                <i
                  class="fa me-1"
                  [ngClass]="market_service.expanded ? 'fa-minus' : 'fa-plus'"
                ></i>
                {{ market_service.service_name }}
              </span>
              <span *ngIf="!market_service.regions?.length">{{
                market_service.service_name
              }}</span>
            </td>
            <ng-container *ngFor="let cost of market_service.costs">
              <td>{{ cost.base }}</td>
              <td>{{ cost.final }}</td>
            </ng-container>
          </tr>

          <ng-container *ngIf="market_service.expanded">
            <ng-container *ngFor="let region of market_service.regions">
              <tr>
                <td class="ps-4">
                  <span
                    *ngIf="region.product_families?.length"
                    (click)="region.expanded = !region.expanded"
                    style="cursor: pointer;"
                  >
                    <i
                      class="fa me-1"
                      [ngClass]="region.expanded ? 'fa-minus' : 'fa-plus'"
                    ></i>
                    {{ region.region }}
                  </span>
                  <span *ngIf="!region.product_families?.length">{{
                    region.region
                  }}</span>
                </td>
                <ng-container *ngFor="let cost of region.costs">
                  <td>{{ cost.base }}</td>
                  <td>{{ cost.final }}</td>
                </ng-container>
              </tr>

              <ng-container *ngIf="region.expanded">
                <ng-container *ngFor="let pf of region.product_families">
                  <tr>
                    <td class="ps-5">{{ pf.name }}</td>
                    <ng-container *ngFor="let cost of pf.costs">
                      <td>{{ cost.base }}</td>
                      <td>{{ cost.final }}</td>
                    </ng-container>
                  </tr>
                </ng-container>
              </ng-container>
            </ng-container>
          </ng-container>
        </ng-container>
      </tbody>
    </table>

    <div
      class="d-flex justify-center align-items-center mt-3"
      *ngIf="marketTotalPages > 1"
    >
      <i
        class="fa fa-angle-left fa-lg cursor-pointer mx-2"
        [class.text-muted]="market_currentPage === 1"
        (click)="marketPrev()"
      ></i>
      <span class="mx-2"
        >Page {{ market_currentPage }} of {{ marketTotalPages }}</span
      >
      <i
        class="fa fa-angle-right fa-lg cursor-pointer mx-2"
        [class.text-muted]="market_currentPage >= marketTotalPages"
        (click)="marketNext()"
      ></i>
    </div>
  </ng-container>

  <ng-template #noDataMarket>
    <div class="text-center text-muted py-3">No data found</div>
  </ng-template>
</div> -->




<div class="section">
  <app-service-chart
    [currentServices]="graph"
    [previousServices]="[]"
    [viewType]="selectedView"
  ></app-service-chart>
</div>

<!-- Header: AWS Company Info -->
<div class="card-header flex justify-between items-center mt-3">
  <div class="exp">
    <h4 class="text-lg font-semibold">Amazon Web Services India Private Limited</h4>
  </div>
  <div class="ser mt-4 d-flex gap-4">
    <div>
      <p>Total active services</p>
      <h5><strong>{{ totactiveser }}</strong></h5>
    </div>
    <div>
      <p>Total service charges in USD</p>
      <h5 class="text-end">
        <strong>
          {{
            total !== null && total !== undefined
              ? (total | number : '1.2-2') + ' USD'
              : '-'
          }}
        </strong>
      </h5>
    </div>
  </div>
</div>

<!-- Preferences and Search -->
<div class="flex-wrap align-items-center justify-content-between p-3 border">
  <div class="d-flex flex-wrap align-items-center gap-4">
    <app-preferences
      [pref]="preferencesData"
      [monthYear]="monthYear"
      [filteredTag]="filteredTag"
      [selectedView]="selectedView"
      [accountId]="accountId"
      (pageSizeChange)="handlePageSizeChange($event)"
      (responseToParent)="handlePreferencesResponse($event)"
    ></app-preferences>
  </div>

  <div class="d-flex flex-wrap align-items-center gap-4 justify-content-between">
    <div class="input-group mb-4 w-50 mt-4">
      <span class="input-group-text bg-white border-end-0">
        <i class="fa-solid fa-magnifying-glass text-muted"></i>
      </span>
      <input
        type="text"
        [(ngModel)]="searchTerm"
        class="form-control border-start-0"
        placeholder="Filter by service or region name"
        (ngModelChange)="onSearch()"
      />
    </div>

    <div>
      <button class="btn btn-outline-primary" (click)="toggleExpandAll()">
        <i class="fa" [ngClass]="isExpandedAll ? 'fa-square-minus' : 'fa-square-plus'"></i>
        {{ isExpandedAll ? 'Minimize All' : 'Expand All' }}
      </button>
    </div>
  </div>
</div>

<!-- AWS Services Table -->
<div class="table-container np-table3">
  <ng-container *ngIf="weekHeaders?.length; else noDataAWS">
    <table class="table table-striped">
      <colgroup>
        <col style="width: auto; white-space: nowrap;" />
        <col *ngFor="let _ of [].constructor(weekHeaders.length * 2)" />
      </colgroup>

      <thead>
        <tr>
          <th>Services</th>
          <ng-container *ngFor="let week of weekHeaders">
            <th colspan="2">{{ week }}</th>
          </ng-container>
        </tr>
        <tr>
          <th></th>
          <ng-container *ngFor="let _ of weekHeaders">
            <th>(Base)</th>
            <th>(Final)</th>
          </ng-container>
        </tr>
      </thead>

      <tbody>
        <tr *ngIf="!filteredList || filteredList.length === 0">
          <td
            [attr.colspan]="weekHeaders?.length * 2 + 1"
            class="text-center text-muted py-3"
          >
            No data found
          </td>
        </tr>

        <ng-container *ngFor="let service of paginatedList">
          <!-- Product Name -->
          <tr class="bg-light">
            <td class="ps-2">
              <span (click)="toggleProductName(service)" style="cursor: pointer;">
                <i
                  class="fa me-1"
                  [ngClass]="isProductNameExpanded(service) ? 'fa-minus' : 'fa-plus'"
                ></i>
                {{ service.product_name }}
              </span>
            </td>
            <ng-container *ngFor="let cost of service.costs">
              <td><strong>{{ cost.base }}</strong></td>
              <td><strong>{{ cost.final }}</strong></td>
            </ng-container>
          </tr>

          <!-- Service Row -->
          <tr *ngIf="isProductNameExpanded(service)" class="bg-white">
            <td class="ps-3">
              <span
                *ngIf="service.regions?.length"
                (click)="toggle(service)"
                style="cursor: pointer;"
              >
                <i
                  class="fa me-1"
                  [ngClass]="service.expanded ? 'fa-minus' : 'fa-plus'"
                ></i>
                {{ service.service_name }}
              </span>
              <span *ngIf="!service.regions?.length">{{ service.service_name }}</span>
            </td>
            <ng-container *ngFor="let cost of service.costs">
              <td><strong>{{ cost.base }}</strong></td>
              <td><strong>{{ cost.final }}</strong></td>
            </ng-container>
          </tr>

          <!-- Regions -->
          <ng-container *ngIf="service.expanded">
            <ng-container *ngFor="let region of service.regions">
              <tr>
                <td class="ps-4">
                  <span
                    *ngIf="region.product_families?.length"
                    (click)="region.expanded = !region.expanded"
                    style="cursor: pointer;"
                  >
                    <i
                      class="fa me-1"
                      [ngClass]="region.expanded ? 'fa-minus' : 'fa-plus'"
                    ></i>
                    {{ region.region }}
                  </span>
                  <span *ngIf="!region.product_families?.length">{{ region.region }}</span>
                </td>
                <ng-container *ngFor="let cost of region.costs">
                  <td>{{ cost.base }}</td>
                  <td>{{ cost.final }}</td>
                </ng-container>
              </tr>

              <ng-container *ngIf="region.expanded">
                <ng-container *ngFor="let pf of region.product_families">
                  <tr>
                    <td class="ps-5">{{ pf.name }}</td>
                    <ng-container *ngFor="let cost of pf.costs">
                      <td>{{ cost.base }}</td>
                      <td>{{ cost.final }}</td>
                    </ng-container>
                  </tr>
                </ng-container>
              </ng-container>
            </ng-container>
          </ng-container>
        </ng-container>
      </tbody>
    </table>

    <!-- Pagination -->
    <div class="d-flex justify-center align-items-center mt-3" *ngIf="totalPages > 1">
      <i
        class="fa fa-angle-left fa-lg cursor-pointer mx-2"
        [class.text-muted]="currentPage === 1"
        (click)="goToPreviousPage()"
      ></i>
      <span class="mx-2">Page {{ currentPage }} of {{ totalPages }}</span>
      <i
        class="fa fa-angle-right fa-lg cursor-pointer mx-2"
        [class.text-muted]="currentPage >= totalPages"
        (click)="goToNextPage()"
      ></i>
    </div>
  </ng-container>

  <ng-template #noDataAWS>
    <div class="text-center text-muted py-3">No data found</div>
  </ng-template>
</div>

<!-- Marketplace Section -->
<div class="card-header flex justify-between items-center mt-3">
  <div class="exp">
    <h4 class="text-lg font-semibold">Amazon Web Services, Inc. - Marketplace</h4>
  </div>
  <div class="ser mt-4 d-flex gap-4">
    <div>
      <p>Total active services</p>
      <h5><strong>{{ market_totactiveser }}</strong></h5>
    </div>
    <div>
      <p>Total service charges in USD</p>
      <h5 class="text-end">
        <strong>
          {{
            market_total != null
              ? (market_total | number : '1.2-2') + ' USD'
              : '-'
          }}
        </strong>
      </h5>
    </div>
  </div>
</div>

<!-- Marketplace Search -->
<div class="d-flex flex-wrap align-items-center justify-content-between p-3 border mt-3">
  <div class="input-group mb-4 w-50 mt-4">
    <span class="input-group-text bg-white border-end-0">
      <i class="fa-solid fa-magnifying-glass text-muted"></i>
    </span>
    <input
      type="text"
      [(ngModel)]="market_searchTerm"
      (ngModelChange)="market_onSearch()"
      class="form-control border-start-0"
      placeholder="Filter by service or region name"
    />
  </div>

  <div>
    <button class="btn btn-outline-primary" (click)="market_toggleExpandAll()">
      <i
        class="fa"
        [ngClass]="market_isExpandedAll ? 'fa-square-minus' : 'fa-square-plus'"
      ></i>
      {{ market_isExpandedAll ? 'Minimize All' : 'Expand All' }}
    </button>
  </div>
</div>

<!-- Marketplace Table -->
<div class="table-container np-table3">
  <ng-container *ngIf="market_weekHeaders?.length; else noDataMarket">
    <table class="table table-striped">
      <colgroup>
        <col style="width: auto; white-space: nowrap;" />
        <col *ngFor="let _ of [].constructor(market_weekHeaders.length * 2)" />
      </colgroup>

      <thead>
        <tr>
          <th>Services</th>
          <ng-container *ngFor="let week of market_weekHeaders">
            <th colspan="2">{{ week }}</th>
          </ng-container>
        </tr>
        <tr>
          <th></th>
          <ng-container *ngFor="let _ of market_weekHeaders">
            <th>(Base)</th>
            <th>(Final)</th>
          </ng-container>
        </tr>
      </thead>

      <tbody>
        <!-- No data -->
        <tr *ngIf="!market_filteredList || market_filteredList.length === 0">
          <td
            [attr.colspan]="market_weekHeaders?.length * 2 + 1"
            class="text-center text-muted py-3"
          >
            No data found
          </td>
        </tr>

        <!-- Marketplace Data -->
        <ng-container *ngFor="let market_service of market_filteredList">
          
          <!-- ✅ Product Name Row (NEW) -->
          <tr class="bg-light" *ngIf="$any(market_service).product_name">
            <td class="ps-2">
              <span
                (click)="toggleProductName(market_service)"
                style="cursor: pointer;"
              >
                <i
                  class="fa me-1"
                  [ngClass]="
                    isProductNameExpanded(market_service)
                      ? 'fa-minus'
                      : 'fa-plus'
                  "
                ></i>
                {{ $any(market_service).product_name }}
              </span>
            </td>
            <ng-container *ngFor="let cost of market_service.costs">
              <td><strong>{{ cost.base }}</strong></td>
              <td><strong>{{ cost.final }}</strong></td>
            </ng-container>
          </tr>

          <!-- Service Row (hidden under product_name toggle) -->
          <tr
            *ngIf="
              !market_service.product_name ||
              isProductNameExpanded(market_service)
            "
          >
            <td class="ps-3">
              <span
                *ngIf="market_service.regions?.length"
                (click)="market_service.expanded = !market_service.expanded"
                style="cursor: pointer;"
              >
                <i
                  class="fa me-1"
                  [ngClass]="
                    market_service.expanded ? 'fa-minus' : 'fa-plus'
                  "
                ></i>
                <!-- Hide product code by default -->
                {{ market_service.service_name }}
              </span>
              <span *ngIf="!market_service.regions?.length">
                {{ market_service.service_name }}
              </span>
            </td>
            <ng-container *ngFor="let cost of market_service.costs">
              <td>{{ cost.base }}</td>
              <td>{{ cost.final }}</td>
            </ng-container>
          </tr>

          <!-- Regions -->
          <ng-container *ngIf="market_service.expanded">
            <ng-container *ngFor="let region of market_service.regions">
              <tr>
                <td class="ps-4">
                  <span
                    *ngIf="region.product_families?.length"
                    (click)="region.expanded = !region.expanded"
                    style="cursor: pointer;"
                  >
                    <i
                      class="fa me-1"
                      [ngClass]="region.expanded ? 'fa-minus' : 'fa-plus'"
                    ></i>
                    {{ region.region }}
                  </span>
                  <span *ngIf="!region.product_families?.length">
                    {{ region.region }}
                  </span>
                </td>
                <ng-container *ngFor="let cost of region.costs">
                  <td>{{ cost.base }}</td>
                  <td>{{ cost.final }}</td>
                </ng-container>
              </tr>

              <!-- Product Families -->
              <ng-container *ngIf="region.expanded">
                <ng-container *ngFor="let pf of region.product_families">
                  <tr>
                    <td class="ps-5">{{ pf.name }}</td>
                    <ng-container *ngFor="let cost of pf.costs">
                      <td>{{ cost.base }}</td>
                      <td>{{ cost.final }}</td>
                    </ng-container>
                  </tr>
                </ng-container>
              </ng-container>
            </ng-container>
          </ng-container>
        </ng-container>
      </tbody>
    </table>

    <!-- Marketplace Pagination -->
    <div
      class="d-flex justify-center align-items-center mt-3"
      *ngIf="marketTotalPages > 1"
    >
      <i
        class="fa fa-angle-left fa-lg cursor-pointer mx-2"
        [class.text-muted]="market_currentPage === 1"
        (click)="marketPrev()"
      ></i>
      <span class="mx-2">
        Page {{ market_currentPage }} of {{ marketTotalPages }}
      </span>
      <i
        class="fa fa-angle-right fa-lg cursor-pointer mx-2"
        [class.text-muted]="market_currentPage >= marketTotalPages"
        (click)="marketNext()"
      ></i>
    </div>
  </ng-container>

  <ng-template #noDataMarket>
    <div class="text-center text-muted py-3">No data found</div>
  </ng-template>
</div>

